"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const includes_1 = tslib_1.__importDefault(require("lodash/includes"));
const entity_1 = require("../type/entity");
function filterOutDeletedStateInteractions(stateInteractions) {
    return stateInteractions.filter(item => !item.deleted);
}
function getStateInteractionByInteractionKeyForLearner(stateInteractions, interactionKeyForLearner) {
    const predicate = (s) => s.contentId_interactionType_interactingOnId_actorId === interactionKeyForLearner;
    const stateInteraction = stateInteractions.find(predicate);
    return stateInteraction;
}
exports.getStateInteractionByInteractionKeyForLearner = getStateInteractionByInteractionKeyForLearner;
function getInteractionOnSubmissionForType(allStateInteractions, contentId, userId, submissionId, interactionType) {
    try {
        const stateInteractions = [];
        allStateInteractions.forEach((stateInteraction) => {
            const interactionKey = `${contentId}_${interactionType}_${submissionId}`;
            if (stateInteraction.contentId === contentId &&
                stateInteraction.userId === userId &&
                includes_1.default(stateInteraction.contentId_interactionType_interactingOnId_actorId, interactionKey)) {
                stateInteractions.push(stateInteraction);
            }
        });
        return filterOutDeletedStateInteractions(stateInteractions);
    }
    catch (error) {
        throw new Error('Error in getInteractionForType ' + error);
    }
}
exports.getInteractionOnSubmissionForType = getInteractionOnSubmissionForType;
function getPeerReviewStateInteractions(stateInteractions, questionId, userId, submissionId) {
    return getInteractionOnSubmissionForType(stateInteractions, questionId, userId, submissionId, entity_1.InteractionType.PeerReview);
}
exports.getPeerReviewStateInteractions = getPeerReviewStateInteractions;
function getPeerReviewStateInteractionOfReviewerOnSubmissionIndex(allStateInteractions, questionId, reviewerId, receiverId, submissionId) {
    const interactionKey = `${questionId}_${entity_1.InteractionType.PeerReview}_${submissionId}_${reviewerId}`;
    const interactionIndex = allStateInteractions.findIndex((stateInteraction) => {
        if (!stateInteraction.deleted &&
            stateInteraction.contentId === questionId &&
            stateInteraction.userId === receiverId &&
            includes_1.default(stateInteraction.contentId_interactionType_interactingOnId_actorId, interactionKey)) {
            return true;
        }
        return false;
    });
    return interactionIndex;
}
exports.getPeerReviewStateInteractionOfReviewerOnSubmissionIndex = getPeerReviewStateInteractionOfReviewerOnSubmissionIndex;
function getPeerReviewStateInteractionOfReviewerOnSubmission(allStateInteractions, questionId, reviewerId, receiverId, submissionId) {
    const interactionKey = `${questionId}_${entity_1.InteractionType.PeerReview}_${submissionId}_${reviewerId}`;
    const stateInteractionOfReviewerOnSubmission = allStateInteractions.find((stateInteraction) => {
        if (!stateInteraction.deleted &&
            stateInteraction.contentId === questionId &&
            stateInteraction.userId === receiverId &&
            includes_1.default(stateInteraction.contentId_interactionType_interactingOnId_actorId, interactionKey)) {
            return true;
        }
        return false;
    });
    return stateInteractionOfReviewerOnSubmission;
}
exports.getPeerReviewStateInteractionOfReviewerOnSubmission = getPeerReviewStateInteractionOfReviewerOnSubmission;
function getFeedbackStateInteractions(stateInteractions, questionId, userId, submissionId) {
    try {
        return getInteractionOnSubmissionForType(stateInteractions, questionId, userId, submissionId, entity_1.InteractionType.Feedback);
    }
    catch (error) {
        throw new Error('Error in getFeedbackStateForInteractions ' + error);
    }
}
exports.getFeedbackStateInteractions = getFeedbackStateInteractions;
function getGradeStateInteractions(stateInteractions, questionId, userId, submissionId) {
    try {
        return getInteractionOnSubmissionForType(stateInteractions, questionId, userId, submissionId, entity_1.InteractionType.Grade);
    }
    catch (error) {
        throw new Error('Error in getGradeStateInteractions ' + error);
    }
}
exports.getGradeStateInteractions = getGradeStateInteractions;
function getEvaluationStateInteractions(stateInteractions, checkpointId, userId, submissionId) {
    try {
        const interactions = getInteractionOnSubmissionForType(stateInteractions, checkpointId, userId, submissionId, entity_1.InteractionType.Evaluation);
        return interactions.filter((evalution) => evalution.reviews && evalution.reviews.length > 0);
    }
    catch (error) {
        throw new Error('Error in getEvaluationStateInteractions ' + error);
    }
}
exports.getEvaluationStateInteractions = getEvaluationStateInteractions;
//# sourceMappingURL=getStateInteraction.js.map